<template>
    <v-chip
        label
        small
        :color="color"
        :text-color="textColor"
    >
        {{ label }}
    </v-chip>
</template>
<script>
export default {
    props: ['status'],

    computed: {
        label() {
            return this.$t(`order_status.${this.status}`);
        },

        color() {
            switch (this.status) {
                case 'completed':
                    return '#c9f7f5';
                case 'pending_payment':
                    return '#e1f0ff';
                case 'pending':
                    return '#e1f0ff';
                case 'canceled':
                    return '#ffe2e5';
            }
        },

        textColor() {
            switch (this.status) {
                case 'completed':
                    return '#1bc5bd';
                case 'canceled':
                    return '#f64e60';
                case 'pending_payment':
                    return '#3699ff';
            }
        }
    }
}
</script>